module.exports = __webpack_public_path__ + "img/logo.22d37efd.png";